import { FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import OnboardingPageContentWrapper from "./onboardingPageContentWrapper/OnboardingPageContentWrapper"
import useMediaQuery from "../../hooks/useMediaQuery"
import useOnboardContext from "../../hooks/useOnboardContext"
import { cohorts } from "../../util/experiments"
import { localStorageItems } from "../../util/storage"
import LinearProgress from "../linearProgress/LinearProgress"
function CreatingPlan() {
  const [progress, setProgress] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const { setCreatingPlan } = useOnboardContext()
  const isSmallMobile = useMediaQuery("(max-width: 500px)")
  const { t } = useTranslation()
  const timerLength = 7000
  const maxPercent = 100
  const numIntervals = 60

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === maxPercent) return maxPercent
        const step = maxPercent / numIntervals
        return Math.min(oldProgress + step, maxPercent)
      })
    }, timerLength / numIntervals)
    const timer = setTimeout(() => setCreatingPlan(false), timerLength)

    return () => {
      clearInterval(interval)
      clearTimeout(timer)
    }
  }, [setCreatingPlan])

  const fadeOut =
    progress < 2 ||
    (progress > 32 && progress < 37) ||
    (progress > 67 && progress < 72)

  const isVariantA =
    localStorage.getItem(localStorageItems.onboardingCustomPlanExperiment) ===
    cohorts.variantA

  return (
    <OnboardingPageContentWrapper backgroundImageOnDesktop="url('/images/background/cloud-bg.png')">
      <FlexBox
        direction="column"
        align="center"
        justify="center"
        gap={SPACING.space4}
      >
        {isVariantA && (
          <Typography variant="h2Serif" textAlign="center">
            {t("CREATING_PLAN_TITLE")}
          </Typography>
        )}
        <img
          src={
            progress < 35
              ? "/images/gifs/onboarding-clipboard-gif.gif"
              : progress < 70
                ? "/images/gifs/onboarding-zoom-search-gif.gif"
                : "/images/gifs/onboarding-routine-cycle-gif.gif"
          }
          alt="Loading"
          style={{
            ...(isSmallMobile
              ? { width: "160px", height: "160px" }
              : { width: "200px", height: "200px" }),
            opacity: isLoading || fadeOut ? 0 : 1,
            transition: "opacity 0.1s ease-in-out",
          }}
          onLoad={() => setIsLoading(false)}
        />
        <Typography
          variant={isVariantA ? "h2" : "h2Serif"}
          textAlign="center"
          style={{
            marginBottom: SPACING.space4,
            height: "64px",
            width: "100%",
            opacity: fadeOut ? 0 : 1,
            transition: "opacity 0.1s ease-in-out",
          }}
        >
          {progress < 35
            ? t("CREATING_PLAN_STEP1")
            : progress < 70
              ? t("CREATING_PLAN_STEP2")
              : t("CREATING_PLAN_STEP3")}
        </Typography>
        <LinearProgress value={progress} withIcon />
      </FlexBox>
    </OnboardingPageContentWrapper>
  )
}

export default CreatingPlan
